import Image from "next/image";
import Link from "next/link";

import { useI18n } from "utils/with-i18n.utils";

import { Calcul } from "./Calcul";
import { Label } from "./Label";
import { Plane } from "./Plane";

export const Co2 = () => {
  const i18n = useI18n();

  return (
    <div className="border-t-[1px] border-black">
      <div className="flex flex-col gap-12 py-7 px-[29.5px] pb-[72px] mx-auto  max-w-[90rem] lg:py-[96px] xl:px-[85px]">
        <div className="flex flex-col-reverse justify-center items-center lg:flex-row">
          <h2 className="text-[30px] text-center md:text-[50px] lg:pl-[45px]">
            {i18n.t("environment.co2.title", {}, { html: true })}
          </h2>
          <span className="self-center w-[28px] h-[28px] lg:mr-8 lg:w-[45px] lg:h-[45px]">
            <Image
              src={"/images/environment/leaf.webp"}
              alt="A green leaf"
              width="45"
              height="45"
            />
          </span>
        </div>
        <Calcul />
        <Plane />
        <Label />
        <div className="text-center">
          <Link href="https://multimedia.ademe.fr/infographies/smartphone-version-ademe">
            <a
              className="text-2xl text-cornflower-blue underline"
              target="_blank"
            >
              {i18n.t("environment.co2.learnMore")}
            </a>
          </Link>
        </div>
      </div>
    </div>
  );
};
